import { render } from "./ResumeCourse.vue?vue&type=template&id=3a9d9544&scoped=true"
import script from "./ResumeCourse.vue?vue&type=script&lang=js"
export * from "./ResumeCourse.vue?vue&type=script&lang=js"

import "./ResumeCourse.vue?vue&type=style&index=0&id=3a9d9544&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3a9d9544"

export default script